import { render, staticRenderFns } from "./LogIn.vue?vue&type=template&id=55230c98&scoped=true&class=true"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"
import style0 from "./LogIn.vue?vue&type=style&index=0&id=55230c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55230c98",
  null
  
)

export default component.exports